import Box from '@/common/components/Box'
import MaintenanceObjective from '@/common/components/MaintenanceObjective'
import { MaintenanceForwardingDirectiveEntryMap } from '@/features/maintenance/features/workflows/types/forwardings/directiveEntries/directiveEntry.type'
import { MaintenanceForwardingData } from '@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type'
import { useMemo } from 'react'
import ExecutionObjectiveActivities from './ExecutionObjectiveActivities'
import ExecutionObjectivePieces from './ExecutionObjectivePieces'

interface ExecutionEntryUpdateObjectiveAttributesProps {
  forwarding:
    | MaintenanceForwardingData<
        MaintenanceForwardingDirectiveEntryMap[MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]
      >
    | undefined
  dataUpdatedAt?: number
}

const ExecutionEntryUpdateObjectiveAttributes = ({
  forwarding,
  dataUpdatedAt,
}: ExecutionEntryUpdateObjectiveAttributesProps) => {
  const objectives = useMemo(() => {
    const objectives = forwarding?.directive_entry?.objectives

    objectives?.sort((a, b) => a.id.localeCompare(b.id))

    return objectives
  }, [dataUpdatedAt])

  const objectiveOffsets = useMemo(() => {
    let pieceOffset = 0
    let activityOffset = 0

    return objectives?.map((objective) => {
      const currentPieceOffset = pieceOffset
      const currentActivityOffset = activityOffset

      pieceOffset += objective.execution_pieces?.length || 0
      activityOffset += objective.execution_activities?.length || 0

      return {
        pieceStartIndex: currentPieceOffset,
        activityStartIndex: currentActivityOffset,
      }
    })
  }, [objectives])

  return (
    <div className="flex flex-col gap-3">
      {objectives?.map((objective, index) => (
        <Box key={objective.id} className="flex flex-col gap-4 p-4 rounded-lg">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4 flex-wrap justify-between">
            <MaintenanceObjective
              systemDisplayName={objective.system.display_name}
              actionDisplayName={objective.action.display_name}
              partDisplayName={objective.part.display_name}
              actionDescription={objective.action.description}
            />
          </div>

          <div className="flex flex-col gap-4">
            <ExecutionObjectivePieces
              executionObjective={objective}
              pieceStartIndex={objectiveOffsets?.[index]?.pieceStartIndex || 0}
            />

            <ExecutionObjectiveActivities
              executionObjective={objective}
              activityStartIndex={objectiveOffsets?.[index]?.activityStartIndex || 0}
            />
          </div>
        </Box>
      ))}
    </div>
  )
}

export default ExecutionEntryUpdateObjectiveAttributes
